import $ from 'jquery';
import 'bootstrap/js/modal';
import Widgets from 'js-widget-hooks';
import React from 'react';
import ReactDOM from 'react-dom';
import app from '../components/app';
import MapsWidget from '../modules/MapsWidget.jsx';

Widgets.register('location-popup', function(el){

    const elem = $(el),
        target = $(elem.data('target')),
        map = target.find('.map'),
        centers = []
    ;

    $('.hook-center').each(function(){
        centers.push($(this).data('center'));
    });

    elem.click(function(e){
        e.preventDefault();
        const center = app.getState('active_center');
        centers.unshift(center);

        target.modal('show');
        target.on('shown.bs.modal', function() {
            if (! elem.data('initialized')) {
                elem.data('initialized', true);

                ReactDOM.render(
                    <MapsWidget defaultLatitude={center.latitude}
                                      defaultLongitude={center.longitude} centers={centers}
                                      mainCenter={center}
                    />,
                    map[0]
                );
            }
        });
    });

});